/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Abilities_Group_DataInputs */



/**
* | output |
* | --- |
* | "Data and code" |
*
* @param {Agent_Builder_Abilities_Group_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_abilities_group_data = /** @type {((inputs?: Agent_Builder_Abilities_Group_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Abilities_Group_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Daten und Code")
	return /** @type {LocalizedString} */ ("Data and code")
});